import { SVGProps } from 'react';

const ThumbScaleMediumKindUpReducedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M9 19V10.5M5 12.7V17.6C5 18.3732 5.64275 19 6.43562 19H16.0731C17.136 19 18.0399 18.2438 18.2015 17.2193L18.9745 12.3193C19.1752 11.0472 18.1659 9.9 16.8461 9.9H14.3315C13.9351 9.9 13.6137 9.5866 13.6137 9.2V6.72609C13.6137 5.7728 12.8212 5 11.8437 5C11.6105 5 11.3992 5.13391 11.3046 5.34169L8.7785 10.8843C8.66329 11.1371 8.40623 11.3 8.12256 11.3H6.43562C5.64275 11.3 5 11.9268 5 12.7Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ThumbScaleMediumKindUpReducedTrue;
